export default __webpack_public_path__ + "static/media/F1_6.f61a6c41.png";